import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
// import { reducer as notificationsReducer } from 'reapop'

import reducerAuth from './reducers/reducerAuth'
import reducerCallAPI from './reducers/reducerCallAPI'
import userReducer from './reducers/user'

import settingsReducer from './reducers/setting'
import infoReducer from './reducers/info'

import RawMaterialReducer from './reducers/rawMaterial'
import TransferReducer from './reducers/transfer'
import materialReducer from './reducers/masterDatas/material'
import warehousesReducer from './reducers/masterDatas/warehouse'
import qrTagReducer from './reducers/qrtag'

export default combineReducers({
    form: formReducer,
    // notifications: notificationsReducer(),
    authen: reducerAuth.authen,
    users: userReducer.users,
    user: userReducer.user,
    callAPI: reducerCallAPI.reducerCallAPI,
    errorList: reducerCallAPI.errorList, //Error list from API
    isLoading: reducerCallAPI.isLoading,
    info: infoReducer.info,
    settings: settingsReducer.setting,

    // fixedRate: fixedRateReducer.fixedRate,
    // estimatePrices: estimatePriceReducer.estimatePrices,
    // estimatePrice: estimatePriceReducer.estimatePrice,
    // variableFix: estimatePriceReducer.variableFix,
    // calculateData: estimatePriceReducer.calculateData,

    // settings: SettingsReducer.setting,

    // isLoading: reducerCallAPI.isLoading,
    materials: materialReducer.masterMaterials,
    warehouses: warehousesReducer.masterWarehouses,

    soPick: qrTagReducer.soPick,
    tagDatas: qrTagReducer.tagDatas,
    tagData: qrTagReducer.tagData,

    transfers: TransferReducer.transfers,
    transfer: TransferReducer.transfer,

    rawMaterials: RawMaterialReducer.rawMaterials,
    changeMaterials: RawMaterialReducer.changeMaterials,
    changeMaterial: RawMaterialReducer.changeMaterial,
    rawMaterialList: RawMaterialReducer.rawMaterialList,
    multiPd: RawMaterialReducer.multiPd,
    multiPdList: RawMaterialReducer.multiPdList,

    rmSummary: RawMaterialReducer.rmSummary,
    rmSummaryList: RawMaterialReducer.rmSummaryList
})


// WEBPACK FOOTER //
// ./src/app/redux/reducers.js